export default {
  'about.eyebrow': 'Làm quen với chúng tôi',
  'about.heroTitle': 'Về Vietnam Travel',
  'about.heroSubtitle': 'Chúng tôi không chỉ cho bạn thấy Việt Nam — mà còn giúp bạn cảm nhận, sống trọn và yêu từng khoảnh khắc của hành trình.',
  'about.home': 'Trang chủ',
  'about.aboutUs': 'Về chúng tôi',
  'about.storyEyebrow': 'Câu chuyện của chúng tôi',
  'about.storyTitleA': 'Sinh ra từ niềm đam mê với',
  'about.storyTitleB': 'Vẻ đẹp Việt Nam',
  'about.storyP1': 'Vietnam Travel được thành lập năm 2011 bởi nhóm hướng dẫn viên địa phương đầy nhiệt huyết với niềm tin rằng du lịch Việt Nam không chỉ là ghé qua các điểm tham quan. Chúng tôi muốn tạo ra những trải nghiệm kết nối du khách với trái tim và linh hồn thực sự của đất nước tuyệt vời này.',
  'about.storyP2': 'Từ một đội ngũ nhỏ 5 hướng dẫn viên tại Hà Nội, chúng tôi đã phát triển thành một trong những công ty lữ hành đáng tin cậy nhất Việt Nam, với văn phòng trên khắp cả nước và hơn 80 chuyên gia tận tâm.',
  'about.storyP3': 'Dù đã phát triển, niềm tin cốt lõi của chúng tôi vẫn không thay đổi: mỗi du khách xứng đáng trải nghiệm Việt Nam không phải như một khách du lịch, mà như một vị khách được chào đón. Chúng tôi tạo nên những hành trình kết hợp các danh thắng nổi tiếng với những điều ít người biết, tạo nên kỷ niệm khó quên.',
  'about.quote': 'Với chúng tôi, du lịch không phải là điểm đến, mà là những con người bạn gặp, những câu chuyện bạn nghe, và những khoảnh khắc khiến bạn nghẹt thở.',
  'about.statsTitle': 'Hành trình của chúng tôi qua những con số',
  'about.statsSubtitle': 'Hơn một thập kỷ tạo nên những trải nghiệm du lịch khó quên khắp Việt Nam.',
  'about.whyEyebrow': 'Vì sao nên đi cùng chúng tôi',
  'about.whyTitleA': 'Điều làm nên',
  'about.whyTitleB': 'Sự khác biệt',
  'about.whySubtitle': 'Chúng tôi vượt xa những tour thông thường để mang đến trải nghiệm phi thường mà bạn sẽ trân trọng mãi mãi.',
  'about.teamEyebrow': 'Gặp gỡ đội ngũ',
  'about.teamTitleA': 'Những con người đứng sau',
  'about.teamTitleB': 'Hành trình của bạn',
  'about.teamSubtitle': 'Những người địa phương đầy nhiệt huyết, sống và thở cùng Việt Nam, sẵn sàng tạo nên chuyến phiêu lưu hoàn hảo cho bạn.',
  'about.ctaTitle': 'Sẵn sàng khám phá Việt Nam cùng chúng tôi?',
  'about.ctaSubtitle': 'Hãy để chuyên gia địa phương tạo nên hành trình trong mơ của bạn. Dù là lần đầu hay lần thứ mười, Việt Nam luôn có điều mới mẻ để khám phá.',
  'about.browseTours': 'Xem các tour của chúng tôi',
  'about.contactUs': 'Liên hệ với chúng tôi',
  'about.heroAlt': 'Phong cảnh Việt Nam',
  'about.ctaAlt': 'Hoàng hôn Vịnh Hạ Long',
  'about.storyAlt1': 'Hướng dẫn viên cùng du khách',
  'about.storyAlt2': 'Đội ngũ lên kế hoạch',
  'about.storyAlt3': 'Những du khách hạnh phúc',
  'about.licenseEyebrow': 'Chính thức & được cấp phép',
  'about.licenseTitleA': 'Giấy phép',
  'about.licenseTitleB': 'Lữ hành quốc tế',
  'about.licenseSubtitle': 'Chúng tôi là đơn vị lữ hành quốc tế được cấp phép đầy đủ bởi Cục Du lịch Quốc gia Việt Nam.',
  'about.licenseCaption': 'Giấy phép Kinh doanh Dịch vụ Lữ hành Quốc tế — do Cục Du lịch Quốc gia Việt Nam cấp.',
  'about.licenseView': 'Xem toàn bộ giấy phép',
  'about.licenseWhyLink': 'Tìm hiểu vì sao nên chọn chúng tôi',
  'about.licenseClose': 'Đóng',
  'about.licenseAlt': 'Giấy phép lữ hành quốc tế của Red Lion International Travel',
};